<template>
    <template v-if="message.messageReactions && Object.keys(message.messageReactions).length > 0">
        <div class="d-flex gap-1 emoji-container">
            <!-- First 4 Reactions -->
            <span class="btn reactions-btn" v-for="(reactionList, reaction) in visibleReactions" :key="reaction">
                <span class="emoji-item">
                    {{ reaction }}
                    <span v-if="reactionList.length > 1">{{ reactionList.length }}</span>
                </span>

                <!-- Dropdown of users for that emoji -->
                <div
                    id="reactions-dropdown"
                    class="dropdown-menu p-0 reactions-dropdown"
                    aria-labelledby="User-Reactions"
                >
                    <div class="users-list" :class="{ 'custom-scrollbar': userOs == 'Windows' }">
                        <span
                            v-for="react in reactionList"
                            :key="react.id"
                            class="d-flex justify-content-between align-items-center px-3 py-2"
                        >
                            <span class="weight-600 name-text">
                                {{ react.senderDetails.firstName }} {{ react.senderDetails.lastName }}
                            </span>

                            <div
                                @click="handleEmoji(react.emoji)"
                                v-if="loggedInUserDetails?.userId === react.senderUserId"
                                class="dialog-close"
                            >
                                <i class="fas fa-times text-secondary"></i>
                            </div>
                        </span>
                    </div>
                </div>
            </span>

            <!-- + EXTRA Reactions Button -->
            <span v-if="extraReactionsCount > 0" class="btn reactions-btn">
                <span class="emoji-item" data-bs-toggle="dropdown" data-bs-offset="0,8">
                    +{{ extraReactionsCount }}
                </span>

                <!-- Dropdown of ALL remaining reactions -->
                <div
                    id="more-reactions-dropdown"
                    class="dropdown-menu p-0 reactions-dropdown"
                    :class="{ 'custom-scrollbar': userOs == 'Windows' }"
                >
                    <div class="users-list p-2" :class="{ 'custom-scrollbar': userOs == 'Windows' }">
                        <div
                            v-for="(reactionList, reaction) in extraReactions"
                            :key="reaction"
                            class="extra-reaction-block"
                        >
                            <div class="fw-bold">
                                {{ reaction }} {{ reactionList.length > 1 ? "(" + reactionList.length + ")" : "" }}
                            </div>

                            <div
                                v-for="react in reactionList"
                                :key="react.id"
                                class="d-flex justify-content-between align-items-center mt-1"
                            >
                                <span class="name-text">
                                    {{ react.senderDetails.firstName }} {{ react.senderDetails.lastName }}
                                </span>

                                <div
                                    @click="handleEmoji(react.emoji)"
                                    v-if="loggedInUserDetails?.userId === react.senderUserId"
                                    class="dialog-close"
                                >
                                    <i class="fas fa-times text-secondary"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </span>

            <EmojiPicker @emoji-selected="handleEmoji" />
        </div>
    </template>
</template>

<script lang="ts" src="./MessageReactions.ts"></script>
<style src="./MessageReactions.scss"></style>
